import React, { createContext, useContext, useEffect, useState } from 'react';
import { signIn, signOutUser, onUserStateChange, signInWithEmail, signUpWithEmail, resetPassword } from '../services/firebase-auth';
import { db } from '../services/firebase-config';
import { doc, setDoc, collection, addDoc, getDocs } from 'firebase/firestore';
// No appId needed for per-user root structure

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onUserStateChange(async (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
      // Initialize folders/documents for new users ONLY if they do not exist
      if (firebaseUser && firebaseUser.uid) {
        // Import getDoc from Firestore
        const { getDoc } = await import('firebase/firestore');
        // budgetState document: users/{uid}/budgetData/v1
        const budgetRef = doc(db, 'users', firebaseUser.uid, 'budgetData', 'v1');
        const budgetSnap = await getDoc(budgetRef);
        if (!budgetSnap.exists()) {
          await setDoc(budgetRef, { tbb: 0, categories: [] });
        }
        // settings/default document: users/{uid}/settings/default
        const settingsRef = doc(db, 'users', firebaseUser.uid, 'settings', 'default');
        const settingsSnap = await getDoc(settingsRef);
        if (!settingsSnap.exists()) {
          await setDoc(settingsRef, { currency: '$' });
        }
        // transactions collection: users/{uid}/transactions
        const txRef = collection(db, 'users', firebaseUser.uid, 'transactions');
        const txSnap = await getDocs(txRef);
        if (txSnap.empty) {
          await addDoc(txRef, { _init: true });
        }
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      signIn,
      signOutUser,
      signInWithEmail,
      signUpWithEmail,
      resetPassword
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
